import React, { FC, useMemo } from 'react';

import {
	EvFlexColumn,
	EvSection,
	TABLE_FILTERS_SR_SUMMARY,
	TEvFiltersPanelValues
} from '@evinced-private/ui-common';

import { WFA_SESSION_FILTERS_SECTION_ID } from 'data-automation-ids/WfaDashboardAutomationIds';
import { useWfaSessionFilterOptionsQuery } from 'src/apps/wfa/hooks/useWfaSessionFilterOptionsQuery';
import { ProductFiltersPanel } from 'src/common/components/pinned-date-range-filters-panel';
import { PLATFORM_APP_ID } from 'src/common/consts/dom-consts';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import {
	buildPanelInitialValues,
	mapPanelValuesToFilters,
	mapToPanelDefinitions
} from 'src/common/helpers/FiltersPanelHelper';

import { wfaSingleSessionFilterDefinitions } from './WfaSingleSessionFilterDefinitions';

interface IWfaSingleSessionFiltersProps {
	sessionId: string;
	filters: IFilterOptions;
	onFilterChange: (tableId: string, filters: IFilterOptions) => void;
	tableId: string;
	ariaLabel: string;
}

export const WfaSingleSessionFiltersSection: FC<IWfaSingleSessionFiltersProps> = ({
	sessionId,
	filters,
	onFilterChange,
	tableId,
	ariaLabel
}) => {
	const filterOptionsQuery = useWfaSessionFilterOptionsQuery(sessionId);

	const panelDefinitions = useMemo(
		() => mapToPanelDefinitions(wfaSingleSessionFilterDefinitions),
		[]
	);

	const initialValues = useMemo<TEvFiltersPanelValues>(
		() => buildPanelInitialValues(panelDefinitions, filters),
		[panelDefinitions, filters]
	);

	const handleApply = (appliedFilters: TEvFiltersPanelValues): void => {
		onFilterChange(tableId, mapPanelValuesToFilters(appliedFilters));
	};

	return (
		<EvSection
			ariaLabel={ariaLabel}
			ariaDescribedby={TABLE_FILTERS_SR_SUMMARY}
			ariaLive="polite"
			skipLinkId="filters-section"
			dataAutomationId={WFA_SESSION_FILTERS_SECTION_ID}
		>
			<EvFlexColumn margin={['LARGE', 'NONE']} align="CENTER">
				<ProductFiltersPanel
					appElement={PLATFORM_APP_ID}
					onApply={handleApply}
					onReset={handleApply}
					initialValues={initialValues}
					filterOptions={filterOptionsQuery.data ?? {}}
					filterDefinitions={panelDefinitions}
				/>
			</EvFlexColumn>
		</EvSection>
	);
};
